// const format = {
//   "id": {user_id},
//   "firstname": "{first_name}",
//   "lastname": "{last_name}",
//   "email": "{user_email}",
//   "roles": [
//     {
//       "id": {role_id},
//       "name": "{role_name}",
//       "permissions": [
//         {
//           "id": {permission_id},
//           "name": "{permission_name}"
//         },
//         {
//           "id": {permission_id},
//           "name": "{permission_name}"
//         }
//       ]
//     },
//     {
//       "id": {role_id},
//       "name": "{role_name}",
//       "permissions": [
//         {
//           "id": {permission_id},
//           "name": "{permission_name}"
//         }
//       ]
//     }
//   ],
//   "hmg": [
//     {
//       "id": {hmg_id},
//       "name": "{hmg_name}",
//       "properties": [
//         {
//           "id": {property_id},
//           "name": "{property_name}"
//         },
//         {
//           "id": {property_id},
//           "name": "{property_name}"
//         }
//       ]
//     },
//     {
//       "id": {hmg_id},
//       "name": "{hmg_name}",
//       "properties": [
//         {
//           "id": {property_id},
//           "name": "{property_name}"
//         },
//         {
//           "id": {property_id},
//           "name": "{property_name}"
//         }
//       ]
//     }
//   ]
// }

export const sampleResponseArr = [
  {
    "id": 1,
    "firstname": "Alice",
    "lastname": "Smith",
    "email": "alice.smith@example.com",
    "roles": [
      {
        "id": 101,
        "name": "Admin",
        "permissions": [
          {
            "id": 201,
            "name": "Create User"
          },
          {
            "id": 202,
            "name": "Delete User"
          }
        ]
      },
      {
        "id": 102,
        "name": "Editor",
        "permissions": [
          {
            "id": 203,
            "name": "Edit Content"
          }
        ]
      }
    ],
    "hmg": [
      {
        "id": 301,
        "name": "Grand Hotel",
        "properties": [
          {
            "id": 2,
            "name": "Oceanview Retreat"
          },
          {
            "id": 3,
            "name": "Skyline Luxury Hotel"
          }
        ]
      },
      {
        "id": 302,
        "name": "Mountain Lodge",
        "properties": [
          {
            "id": 4,
            "name": "Urban Oasis Suites"
          },
          {
            "id": 1,
            "name": "Seaside Inn"
          },
          {
            "id": 117,
            "name": "Aloft Arundel Mills BWI Airport"
          }
        ]
      }
    ]
  },
  {
    "id": 2,
    "firstname": "Bob",
    "lastname": "Johnson",
    "email": "bob.johnson@example.com",
    "roles": [
      {
        "id": 103,
        "name": "User",
        "permissions": [
          {
            "id": 205,
            "name": "View Content"
          }
        ]
      }
    ],
    "hmg": [
      {
        "id": 303,
        "name": "City Center Inn",
        "properties": [
          {
            "id": 405,
            "name": "Complimentary Breakfast"
          },
          {
            "id": 406,
            "name": "City View"
          }
        ]
      }
    ]
  },
  {
    "id": 3,
    "firstname": "Carol",
    "lastname": "Williams",
    "email": "carol.williams@example.com",
    "roles": [
      {
        "id": 104,
        "name": "Manager",
        "permissions": [
          {
            "id": 207,
            "name": "Approve Requests"
          },
          {
            "id": 208,
            "name": "View Reports"
          }
        ]
      }
    ],
    "hmg": [
      {
        "id": 304,
        "name": "Seaside Resort",
        "properties": [
          {
            "id": 407,
            "name": "Spa Services"
          }
        ]
      }
    ]
  },
  {
    "id": 4,
    "firstname": "David",
    "lastname": "Brown",
    "email": "david.brown@example.com",
    "roles": [
      {
        "id": 105,
        "name": "Contributor",
        "permissions": [
          {
            "id": 209,
            "name": "Submit Content"
          }
        ]
      },
      {
        "id": 106,
        "name": "Viewer",
        "permissions": [
          {
            "id": 210,
            "name": "Access Reports"
          }
        ]
      }
    ],
    "hmg": [
      {
        "id": 305,
        "name": "Cozy Bungalow",
        "properties": [
          {
            "id": 408,
            "name": "Garden Access"
          },
          {
            "id": 409,
            "name": "Pet-Friendly"
          }
        ]
      },
      {
        "id": 306,
        "name": "Executive Suites",
        "properties": [
          {
            "id": 410,
            "name": "Business Center"
          }
        ]
      }
    ]
  }
]

export const samplePlanArr = [
  {
    "id": 0,
    "planStatusId": 2,
    "planTypeId": 2,
    "planDescription": "xyz",
    "fiscalYear": 2024,
    "propertyId": 1,
    "versionName": "2",
    "versionNumber": 1,
    "startYearMonth": 12024,
    "endYearMonth": 122024,
    "revenueType": "xyz",
    "entryMonth": 7,
    "autoRefreshRevDaily": false,
    "readOnly": false,
    "asOnDate": 4102024,
    "createdBy": "demo user",
    "createdOn": "2024-10-03T16:07:11.236+00:00",
    "modifiedBy": "demo user",
    "modifiedOn": "2024-10-03T16:07:11.236+00:00",
    "entryWeek": 1
  },
  {
    "id": 102,
    "planStatusId": 2,
    "planTypeId": 2,
    "planDescription": "xyz",
    "fiscalYear": 2020,
    "propertyId": 2,
    "versionName": "2",
    "versionNumber": 1,
    "startYearMonth": 12024,
    "endYearMonth": 122024,
    "revenueType": "app",
    "entryMonth": 7,
    "autoRefreshRevDaily": false,
    "readOnly": false,
    "asOnDate": 4102024,
    "createdBy": "demo user",
    "createdOn": "2024-10-03T16:07:11.236+00:00",
    "modifiedBy": "demo user",
    "modifiedOn": "2024-10-03T16:07:11.236+00:00",
    "entryWeek": 1
  },
  {
    "id": 300,
    "planStatusId": 1,
    "planTypeId": 2,
    "planDescription": "xyz",
    "fiscalYear": 2021,
    "propertyId": 3,
    "versionName": "2",
    "versionNumber": 1,
    "startYearMonth": 12024,
    "endYearMonth": 122024,
    "revenueType": "xyz",
    "entryMonth": 7,
    "autoRefreshRevDaily": false,
    "readOnly": false,
    "asOnDate": 4102024,
    "createdBy": "demo user",
    "createdOn": "2024-10-03T16:07:11.236+00:00",
    "modifiedBy": "demo user",
    "modifiedOn": "2024-10-03T16:07:11.236+00:00",
    "entryWeek": 1
  },
  {
    "id": 301,
    "planStatusId": 2,
    "planTypeId": 2,
    "planDescription": "xyz",
    "fiscalYear": 2021,
    "propertyId": 4,
    "versionName": "2",
    "versionNumber": 1,
    "startYearMonth": 12024,
    "endYearMonth": 122024,
    "revenueType": "xyz",
    "entryMonth": 7,
    "autoRefreshRevDaily": false,
    "readOnly": false,
    "asOnDate": 4102024,
    "createdBy": "demo user",
    "createdOn": "2024-10-03T16:07:11.236+00:00",
    "modifiedBy": "demo user",
    "modifiedOn": "2024-10-03T16:07:11.236+00:00",
    "entryWeek": 1
  },
  {
    "id": 400,
    "planStatusId": 1,
    "planTypeId": 1,
    "planDescription": "xyz",
    "fiscalYear": 2021,
    "propertyId": 4,
    "versionName": "2",
    "versionNumber": 2,
    "startYearMonth": 12024,
    "endYearMonth": 122024,
    "revenueType": "xyz",
    "entryMonth": 7,
    "autoRefreshRevDaily": false,
    "readOnly": false,
    "asOnDate": 4102024,
    "createdBy": "demo user",
    "createdOn": "2024-10-03T16:07:11.236+00:00",
    "modifiedBy": "demo user",
    "modifiedOn": "2024-10-03T16:07:11.236+00:00",
    "entryWeek": 1
  }
]

export const samplePropertyArr = [
  {id:1,name:"Seaside inn",dateFormat:'MMM d, yyyy'},
  {id:2, name:"Oceanview Retreat",dateFormat:'MM/dd/yyyy'},
  {id:3, name:"Skyline Luxury Hotel",dateFormat:'MMMM dd, yy'},
  {id:4, name: "Urban Oasis Suites",dateFormat:'EEEE MM dd, yyyy'},
  {id:117, name: "Aloft Arundel Mills BWI Airport",dateFormat:'EEEE MM dd, yyyy'}
]

export const samplePlanTypeArr = [
  {
    // "id": 1,
    "name": "Budget",
    "description": "Budget plan type",
    "active": true,
    "defaultMonth": 12
  },
  {
    // "id": 3,
    "name": "What if",
    "description": "What if plan type",
    "active": true,
    "defaultMonth": 12
  },
  {
    // "id": 2,
    "name": "Forecast",
    "description": "Forecast plan type",
    "active": true,
    "defaultMonth": 12
  }
];

export const samplePlanStatusArr = [
  {
    "id": 1,
    "name": "Final",
    "description": "final plan status",
    "active": true
  },
  {
    "id": 2,
    "name": "Draft",
    "description": "draft plan status",
    "active": true
  }
];